import { axiosAPI } from 'utils';

const fallback = (error) => {
  console.error(error);
  return error?.response?.data || { success: false, error: error?.message || 'Request failed' };
};

export default {
  get() {
    return axiosAPI.get('api/admin/haitian-tts-settings').then((res) => res.data).catch(fallback);
  },
  update(params) {
    return axiosAPI.put('api/admin/haitian-tts-settings', params).then((res) => res.data).catch(fallback);
  },
};
